export default __webpack_public_path__ + "static/media/bass_outside.bb05411e.jpg";